import { Button, Grid2 as Grid, Typography } from "@mui/material";
import { useState } from "react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { AgGridReact } from "ag-grid-react";
import { CatalogElement } from "../../../models/CatalogElement";
import { useGridStyles } from "../../../styles/gridStyles";
import { CreateElement } from "./CreateElement";
import { EditElement } from "./EditElement";
import { useTableData } from "./hooks";

type Props = {
	getCatalogElementsFromAPI: Function;
	isLoading: boolean;
};

export const TableElement = ({
	getCatalogElementsFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [idElement, setIdElement] = useState<number | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns, defaultColDef } = useTableData({});
	const { columnDefaults, columnTypes } = useGridDefinitions({
		OnEdit: (data: CatalogElement) => {
			setShowEditModal(!showEditModal);
			setIdElement(data.ElementId);
		},
	});

	const classes = useGridStyles();
	return (
		<>
			<Grid size={{ xs: 12 }} container justifyContent="center" spacing={1}>
				<Grid size={{ xs: 12, md: 12 }}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Elements
					</Typography>
				</Grid>

				<Grid
					size={{ xs: 12 }}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid size={{ xs: 12 }} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search elements"
						/>
					</Grid>
					<Grid
						size={{ xs: 12, md: 12 }}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.ElementId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setIdElement(params.data.ElementId);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid size={{ xs: 12, md: "auto" }} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW ELEMENT
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateElement
				show={showCreateModal}
				onHide={() => setShowCreateModal(false)}
				refreshData={getCatalogElementsFromAPI}
			/>
			<EditElement
				show={showEditModal}
				onHide={(updated: boolean) => {
					setShowEditModal(false);
					setIdElement(null);
					if (updated) getCatalogElementsFromAPI();
				}}
				elementId={idElement}
			/>
		</>
	);
};
